import { render } from "./AuxSelector.vue?vue&type=template&id=51343b10&ts=true"
import script from "./AuxSelector.vue?vue&type=script&lang=ts"
export * from "./AuxSelector.vue?vue&type=script&lang=ts"

import "./AuxSelector.vue?vue&type=style&index=0&id=51343b10&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QDialog});
